import { nanoid } from 'nanoid';
import * as QuestionnaireApiModels from '@typings/questionnaires-api-models';

type ThisFieldTemplate = Pick<QuestionnaireApiModels.FieldTemplate, 'id' | 'key' | 'type'>;

const formValuesToResponses = (
  formValues: Record<string, unknown>,
  getResponseSource: (fieldKey: string) => QuestionnaireApiModels.QuestionnaireResponse['source'],
  getAiRequestId: (fieldKey: string) => string | null,
  sections: {
    fields: ThisFieldTemplate[];
  }[],
  isInListOrTable: (fieldId: string) => boolean,
): QuestionnaireApiModels.UpdateResponseData => {
  const fieldTemplatesMap: Record<string, ThisFieldTemplate> = {};
  sections.forEach(section => {
    section.fields.forEach(field => {
      fieldTemplatesMap[field.key] = field;
    });
  });

  const responses: Record<string,
    | QuestionnaireApiModels.UpdateResponseDataBasic
    | QuestionnaireApiModels.UpdateResponseDataList
  > = {};

  Object.keys(formValues)
    .filter((key) => formValues[key] !== undefined)
    .forEach((key) => {
      const fieldTemplate = fieldTemplatesMap[key];
      if (fieldTemplate?.id) {
        if (fieldTemplate.type === 'list' || fieldTemplate.type === 'table') {
          const rows = formValues[key];
          const listResponses: {
            id: string | null;
            associatedWithId: string | null;
            values: Record<string, { value: unknown; source: QuestionnaireApiModels.QuestionnaireResponse['source'] }>
          }[] = [];
          if (Array.isArray(rows)) {
            rows.forEach((listRow, index) => {
              const rowResponses: Record<string, {
                value: unknown;
                aiRequestId:string | null;
                source: QuestionnaireApiModels.QuestionnaireResponse['source'];
              }> = {};
              if (listRow && typeof listRow === 'object') {
                Object.keys(listRow)
                  .filter((listKey) => listRow[listKey] !== undefined)
                  .forEach(listKey => {
                    const subFieldTemplate = fieldTemplatesMap[listKey];
                    if (subFieldTemplate?.id) {
                      rowResponses[listKey] = {
                        aiRequestId: getAiRequestId(`${fieldTemplate.key}[${index}].${listKey}`) ?? null,
                        source: getResponseSource(`${fieldTemplate.key}[${index}].${listKey}`) ?? 'unknown',
                        value: listRow[listKey],
                      };
                    }
                  });
              }
              listResponses.push({
                associatedWithId: listRow?._associatedWithId ?? null,
                id: listRow?._id ?? nanoid(),
                values: rowResponses,
              });
            });
          }
          responses[key] = listResponses;
        } else if (!isInListOrTable(fieldTemplate.id)) {
          responses[key] = {
            aiRequestId: getAiRequestId(key) ?? null,
            source: getResponseSource(key) ?? 'unknown',
            value: formValues[key],
          };
        }
      }
    });
  return responses;
};

export default formValuesToResponses;